/**
 * "This tab has just logged in."
 *
 * A page reload and a fresh login look identical from inside the app: both read the same tokens
 * out of localStorage and resolve the same user. The welcome-back dialog must only follow a real
 * login, so the two places a login completes (AuthCallback for Google, Login for the password
 * path) leave this marker behind before navigating into the app.
 *
 * sessionStorage, not localStorage: it belongs to this tab, survives the in-app redirect after
 * login, and does not leak into another tab the person opens later. The value is the user id, so
 * a marker left by one account can never open the dialog for another.
 *
 * Every access is wrapped: storage can throw in private windows or when blocked, and a failure
 * here must only ever mean "no dialog", never a broken login.
 */

const KEY = 'gracklecrm_fresh_login'

export function markFreshLogin(userId: string): void {
  try {
    sessionStorage.setItem(KEY, userId)
  } catch {
    // No storage: the dialog simply won't appear.
  }
}

/** The user id that just logged in in this tab, if any. Does not clear it. */
export function peekFreshLogin(): string | null {
  try {
    return sessionStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function clearFreshLogin(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing to clear.
  }
}
